var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('v-card',{staticClass:"mx-auto",attrs:{"tile":""}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }